// The two ways `POST /esign/{token}/code` refuses to send, as STATUS CODES.
//
// It used to refuse with `200 {"status": "rate_limited" | "locked_out"}` — a success
// status carrying a "no" in the body. Every caller had to remember to read past the
// status line to notice that no email had gone out, and callers forgot: a throttled
// signer was advanced to the code-entry screen and left waiting for an email nobody had
// sent. The server now answers with real error statuses (`routers/esign_signer.py`), so
// the default behaviour of any caller — including one written later that has never heard
// of these constants — is to fail, because they all already handle a rejected fetch.
//
// These exist so the two refusals can be told APART, which is the only thing left that
// needs deliberate handling. `publicFetch` turns both into a `PublicApiError` carrying
// `status`; nothing needs to look in the body.

/** The hourly cap on REQUESTING codes. Clears itself; the signer can retry shortly. */
export const SEND_CODE_THROTTLED_STATUS = 429;

/**
 * The envelope is shut after too many wrong GUESSES. Distinct from the throttle
 * because it belongs on a different screen: there is a live code-entry form to
 * disable, and no amount of re-requesting will open it.
 */
export const SEND_CODE_LOCKED_OUT_STATUS = 423;
